import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import patientsContext from './patientsContext';
import ApiClient from '../Services/ApiClient';
import { Patient } from '../../Models/Patient';

const PatientsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [patients, setPatients] = useState<Patient[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);

    const fetchPatients = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await ApiClient.get('/patients');
            setPatients(Array.isArray(result) ? result : []);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // initial load
        fetchPatients();
    }, [fetchPatients]);

    // Cache helpers exposed to consumers
    const addPatientToCache = useCallback((p: Patient) => {
        setPatients(prev => [p, ...(prev ?? [])]);
    }, []);

    const updatePatientInCache = useCallback((p: Patient) => {
        setPatients(prev => (prev ?? []).map((x: Patient) => x.id === p.id ? { ...x, ...p } : x));
    }, []);

    const removePatientFromCache = useCallback((id: number) => {
        setPatients(prev => (prev ?? []).filter((x: Patient) => x.id !== id));
    }, []);

    return (
        <patientsContext.Provider value={[loading, error, patients, fetchPatients, addPatientToCache, updatePatientInCache, removePatientFromCache]}>
            {children}
        </patientsContext.Provider>
    );
};

export default PatientsProvider;